export const DB_CONFIG = {
    apiKey: "AIzaSyD2CL435uTeIuZveS2oMBabJNwaegJBanE",
    authDomain: "lockdown-prepuzzel.firebaseapp.com",
    projectId: "lockdown-prepuzzel",
    storageBucket: "lockdown-prepuzzel.appspot.com",
    messagingSenderId: "656898853907",
    appId: "1:656898853907:web:2a66ab0d16a0a7615c03e6",
    measurementId: "G-FBFMYPR1HQ"
};
